var _g, _defs;
const _excluded = ["svgRef"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
const SvgShareGray = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7855 17.6999C16.6855 17.6999 16.5855 17.6999 16.4855 17.5999L7.48555 12.3999C7.38555 12.3999 7.18555 12.1999 7.18555 11.9999C7.18555 11.7999 7.28555 11.5999 7.48555 11.4999L16.4855 6.29985C16.7855 6.09985 17.0855 6.19985 17.2855 6.49985C17.4855 6.79985 17.3855 7.09985 17.0855 7.29985L8.98555 11.9999L17.0855 16.6999C17.3855 16.8999 17.4855 17.1999 17.2855 17.4999C17.1855 17.5999 16.9855 17.6999 16.7855 17.6999Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08516 14.8002C8.63155 14.8002 9.88516 13.5466 9.88516 12.0002C9.88516 10.4538 8.63155 9.2002 7.08516 9.2002C5.53876 9.2002 4.28516 10.4538 4.28516 12.0002C4.28516 13.5466 5.53876 14.8002 7.08516 14.8002Z",
    fill: "#D8D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M5.98516 9.40039C4.98516 9.80039 4.28516 10.8004 4.28516 12.0004C4.28516 13.6004 5.58516 14.8004 7.08516 14.8004C7.88516 14.8004 8.68516 14.4004 9.18516 13.8004C4.78516 14.4004 4.48516 11.0004 5.98516 9.40039Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4855 9.6C19.0319 9.6 20.2855 8.3464 20.2855 6.8C20.2855 5.2536 19.0319 4 17.4855 4C15.9391 4 14.6855 5.2536 14.6855 6.8C14.6855 8.3464 15.9391 9.6 17.4855 9.6Z",
    fill: "#D8D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M16.3855 4.2002C15.3855 4.6002 14.6855 5.6002 14.6855 6.8002C14.6855 8.4002 15.9855 9.6002 17.4855 9.6002C18.2855 9.6002 19.0855 9.2002 19.5855 8.6002C15.0855 9.2002 14.8855 5.8002 16.3855 4.2002Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4855 19.9999C19.0319 19.9999 20.2855 18.7463 20.2855 17.1999C20.2855 15.6535 19.0319 14.3999 17.4855 14.3999C15.9391 14.3999 14.6855 15.6535 14.6855 17.1999C14.6855 18.7463 15.9391 19.9999 17.4855 19.9999Z",
    fill: "#D8D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M16.3855 14.6001C15.3855 15.0001 14.6855 16.0001 14.6855 17.2001C14.6855 18.8001 15.9855 20.0001 17.4855 20.0001C18.2855 20.0001 19.0855 19.6001 19.5855 19.0001C15.0855 19.6001 14.8855 16.1001 16.3855 14.6001Z",
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4.28516 4)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShareGray, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ShareGray.5d79d0e3.svg";
export { ForwardRef as ReactComponent };